module.exports = __webpack_public_path__ + "img/eamon-hurley-concorde-rotary-drag-bike.cf05bde9.png";